module.exports = __webpack_public_path__ + "img/td-icon4.c8b50b6a.png";